import { render, staticRenderFns } from "./ResponseCard.vue?vue&type=template&id=79351424&scoped=true&"
import script from "./ResponseCard.vue?vue&type=script&lang=js&"
export * from "./ResponseCard.vue?vue&type=script&lang=js&"
import style0 from "./ResponseCard.vue?vue&type=style&index=0&id=79351424&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79351424",
  null
  
)

export default component.exports